<template>
	<div class="sidebar">
		<div class="loggo" @click="logodian">
			<img src="../../assets/img/logos.png" alt />
		</div>
		<div class="navs clearfix">
			<div>
				<div v-for="(item,index) in items" :key="index" class="items">
					<div class="first" @click="yiji(item.title,index,item,2)">
						<img :src="imgUrl+item.icon" alt />
						<span :class="yijis==index?'lanses':''">{{item.title}}</span>
						<i class="el-icon-arrow-down" v-if="item.children"></i>
					</div>
					<div class="erblock">
						<div v-for="(itemss,indexs) in item.children" :key="indexs" class="erjiyanse">
							<div class="seconds" @click="sanjis(index,indexs,itemss,item.title,itemss.title,2)">
								<span :class="sanji==indexs&&firstindex == index?'lanses':''">{{itemss.title}}</span>
								<i class="el-icon-arrow-down" v-if="itemss.children"></i>
							</div>
							<div v-for="(itemsan,indexsan) in itemss.children" :key="indexsan" class="three" @click="yanse(indexsan,itemsan,item.title,itemss.title,itemsan.title,2)">
								<span :class="activeyan==indexsan?'lanses':''">{{itemsan.title}}</span>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>




	</div>
</template>
<script>
	import Bus from '../../assets/js/bus.js'
	export default {
		data() {
			return {
				url: this.$store.state.p_url,
				imgUrl: this.$store.state.img_url,
				items: [],
				yijis: 0,
				sanji: -1,
				activeyan: "",
				firstindex: -1,
				// 面包屑
				emitObj: {},
				breadArr: [],
			};
		},
		methods: {
			menuList() {
				let that = this;
				that.$axios.post(that.url + "service/auth/menuList", '', {
					headers: {
						admin: window.sessionStorage.getItem('admin')
					}
				}).then(res => {
					that.items = res.data.data;
					setTimeout(function(){
						var breadArr = [];
						//2.开始拼装新数组
						

					
						if(sessionStorage.getItem("firstindex")){
							var firstobj = JSON.parse(sessionStorage.getItem("firstindex"));
							var index = firstobj.index;
							$(".items").eq(index).find(".erblock").slideDown();
							if(sessionStorage.getItem("sethodsindex")){
								var sethobj = JSON.parse(sessionStorage.getItem("sethodsindex"));
								var erindex = sethobj.index;
								that.sanji = erindex;
								that.firstindex = index;
								that.yijis = -1;
								that.activeyan = -1;
								$(".items").eq(index).find(".erjiyanse").eq(erindex).find(".three").slideDown();
								that.breadArr = [
									{
										"title": firstobj.title,
										"route": ""
									},
									{
										"title": sethobj.item.title,
										"route":  sethobj.item.name
									}
								]
								Bus.$emit('emitObj', that.breadArr);
							}else{
								that.sanji = -1;
								that.yijis = 0;
								that.activeyan = -1;
								that.firstindex = -1;
								that.breadArr = [
									{
										"title": firstobj.title,
										"route": firstobj.name
									}
								]
								Bus.$emit('emitObj', that.breadArr);
							}
							if(sessionStorage.getItem("threeindex")){
								var threeobj = JSON.parse(sessionStorage.getItem("threeindex"));
								that.breadArr = [
									{
										"title": firstobj.title,
										"route": ""
									},
									{
										"title": sethobj.item.title,
										"route": ""
									},
									{
										"title": threeobj.item.title,
										"route": threeobj.item.name
									}
								]
								Bus.$emit('emitObj', that.breadArr);
								var threeindex = threeobj.index;
								that.sanji = -1;
								that.yijis = -1;
								that.activeyan = threeindex;
							}
						}
					},500)
				});
			},


			yiji(title, index, item, type) {
				// console.log(title)
				this.removein();
				this.sanji = -1;
				(this.yijis = -1), (this.activeyan = -1);
				if (item.children) {
					$(".items").eq(index).find(".erblock").slideToggle();
				} else {
					this.$router.push({
						path: item.name
					});
					this.yijis = index
				}
				$(".items").eq(index).find(".erjiyanse").find(".three").hide();
				$(".items").eq(index).siblings('.items').find(".erblock").slideUp();
				
				var obj = {
					index: index,
					title: title,
					name:item.name
				}
				sessionStorage.setItem("firstindex", JSON.stringify(obj));
				
				sessionStorage.removeItem("threeindex");
				sessionStorage.removeItem("sethodsindex");

				// [面包屑]
				this.breadArr = []
				var emitObj = {
					"title": title,
					"route": item.name
				}
				this.breadArr.push(emitObj)
				// console.log(this.breadArr)
				Bus.$emit('emitObj', this.breadArr); //发射
				Bus.$emit('chen_coursename', ''); 
				Bus.$emit('chen_classname','');
				Bus.$emit('chen_specname','')

			},
			sanjis(index, erindex, itemss, title1, title2, type) {
				this.removein();
				// [面包屑]
				//1.把通用数组重置
				this.breadArr = [];
				let route = "";

				this.firstindex = -1;
				if (itemss.children) {
					this.sanji = -1;
					(this.yijis = -1), (this.activeyan = -1);
					$(".items").eq(index).find(".erjiyanse").eq(erindex).find(".three").slideToggle();
				} else {
					$(".items").eq(index).find(".erjiyanse").find(".three").hide();
					this.sanji = erindex;
					this.firstindex = index;
					(this.yijis = -1), (this.activeyan = -1);
					this.$router.push({
						path: itemss.name
					});

					//设置路由地址
					route = itemss.name
				}

				var obj = {
					index: erindex,
					item: itemss,
				}
				sessionStorage.setItem("sethodsindex", JSON.stringify(obj));
				
				sessionStorage.removeItem("threeindex");


				//2.开始拼装新数组
				var emitObj1 = {
					"title": title1,
					"route": route
				}
				this.breadArr.push(emitObj1)

				var emitObj2 = {
					"title": title2,
					"route": route
				}
				this.breadArr.push(emitObj2)

				Bus.$emit('emitObj', this.breadArr);
				Bus.$emit('chen_coursename', ''); 
				Bus.$emit('chen_classname','');
				Bus.$emit('chen_specname','')
			},
			yanse(index, itemss, title1, title2, title3, type) {
				this.removein();
				// [面包屑]
				//1.把通用数组重置
				this.breadArr = [];
				this.firstindex = -1
				this.activeyan = index;
				this.$router.push({
					path: itemss.name
				});
				var obj = {
					index: index,
					item: itemss
				}

				sessionStorage.setItem("threeindex", JSON.stringify(obj));

				//2.开始拼装新数组
				var emitObj1 = {
					"title": title1,
					"route": ""
				}
				this.breadArr.push(emitObj1)

				var emitObj2 = {
					"title": title2,
					"route": ""
				}
				this.breadArr.push(emitObj2)

				var emitObj3 = {
					"title": title3,
					"route": itemss.name
				}
				this.breadArr.push(emitObj3)

				Bus.$emit('emitObj', this.breadArr);
				Bus.$emit('chen_coursename', ''); 
				Bus.$emit('chen_classname','');
				Bus.$emit('chen_specname','')
			},
			
			removein(){
                if(sessionStorage.getItem('chapterobj')){
                    sessionStorage.removeItem('chapterobj');
                }
                if(sessionStorage.getItem('cateobj')){
                    sessionStorage.removeItem('cateobj')
                }
				if(sessionStorage.getItem('subobj')){
					sessionStorage.removeItem('subobj');
					sessionStorage.removeItem('testobj');
					sessionStorage.removeItem('testobjsec'); 
					sessionStorage.removeItem('pagetext');
					sessionStorage.removeItem('comobjsec');
					sessionStorage.removeItem('compuobj');
					sessionStorage.removeItem('quesobjsec');
					sessionStorage.removeItem('sethodsindex');
					sessionStorage.removeItem('quesobj');
				}
				if(sessionStorage.getItem('sublistobj')){
					sessionStorage.removeItem('sublistobj');
					sessionStorage.removeItem('quesobj');
					sessionStorage.removeItem('quesobjsec');
					sessionStorage.removeItem('pagesubjiect');
					sessionStorage.removeItem('sethodsindex');
				}
				if(sessionStorage.getItem('comlistobj')){
					sessionStorage.removeItem('comlistobj');
					sessionStorage.removeItem('pagecomputer');
				}
				if(sessionStorage.getItem('th_index')){
					sessionStorage.removeItem('first_index');
					sessionStorage.removeItem('er_index');
					sessionStorage.removeItem('th_index');
				}
				if(sessionStorage.getItem('is_from')){
					sessionStorage.removeItem('is_from');
				}
				if(sessionStorage.getItem('vipcenter')){
					sessionStorage.removeItem('vipcenter')
				}
				if(sessionStorage.getItem('getcusindex')){
					sessionStorage.removeItem('getcusindex')
				}

				sessionStorage.removeItem('sublistobj')
				sessionStorage.removeItem('pagesubjiect')
				if(sessionStorage.getItem('testobjsec')){
					sessionStorage.removeItem('testobjsec')
				}
				if(sessionStorage.getItem('testobj')){
					sessionStorage.removeItem('testobj')
				}
				if(sessionStorage.getItem('taoobjiszhen')){
					sessionStorage.removeItem('taoobjiszhen');
				}
				if(sessionStorage.getItem('iszhenpage')){
					sessionStorage.removeItem('iszhenpage');
				}
				
			},




			getZero(val) {
				// console.log(val)
				if (val == false) {
					$('.items').find(".erblock").slideUp();
				}

			},
			logodian() {
				this.$router.push({
					path: '/overview'
				});
			}



		},
		mounted() {
			var that = this;
			that.menuList();
			Bus.$on('shou', this.getZero); //发射

		}
	};
</script>
<style scoped>
	.sidebar {
		position: fixed;
		left: 0;
		top: 0;
		width: 190px;
		height: 100%;
		overflow-x: hidden;
		overflow-y: scroll;
		background-color: #545c64;
		z-index: 99999;
	}

	.sidebar::-webkit-scrollbar {
		display: none;
	}

	.loggo {
		width: 190px;
		height: 70px;
	}

	.loggo img {
		width: 100%;
		height: 100%;
	}

	.navs {
		width: 190px;
		display: block;
		height: 100%;
		background-color: #303945;
		cursor: pointer;
	}

	.navs::-webkit-scrollbar {
		width: 0px;
		height: 0px;
	}

	.navs::-webkit-scrollbar-thumb {
		border-radius: 0px;
	}

	.navs::-webkit-scrollbar-track {
		border-radius: 0;
	}

	.items {
		width: 100%;
		min-height: 56px;
		background-color: #cccccc;
	}

	.item-er {
		display: none;
	}

	.erjiyanse {
		width: 190px;
		min-height: 56px;
		background-color: #434a50;
		/* display: none; */
	}

	.erblock {
		width: 190px;
		height: auto;
		background-color: #434a50;
		display: none;
	}

	.first {
		width: 100%;
		height: 56px;
		background-color: #303945;
		line-height: 56px;
	}

	.first span {
		font-size: 14px;
		color: #ffffff;
	}

	.first i {
		color: #889097;
		line-height: 56px;
	}

	.first i:nth-of-type(1) {
		margin-right: 18px;
		float: right;
	}

	.first i:nth-of-type(2) {
		float: right;
		margin-right: 18px;
	}

	.first span {
		margin-left: 12px;
	}

	.seconds {
		width: 100%;
		height: 56px;
		background-color: #1f2d3d;
		line-height: 56px;
		color: #aaafb5;
		font-size: 12px;
	}

	.seconds span {
		margin-left: 28px;
	}

	.three {
		width: 190px;
		height: 56px;
		line-height: 56px;
		color: #aaafb5;
		font-size: 12px;
		background-color: #001528;
		text-indent: 28px;
		display: none;
	}

	.seconds i {
		float: right;
		margin-right: 18px;
		line-height: 56px;
	}

	.lanses {
		color: #409eff !important;
	}

	.first img {
		margin-top: 17px;
		margin-left: 18px;
	}
</style>



// WEBPACK FOOTER //
// src/components/comment/sidebar.vue